<template>
  <v-tabs>
    <v-tab>Data Fixer</v-tab>
    <v-tab>Data Eraser</v-tab>

    <v-tab-item>
      <Fixer />
    </v-tab-item>
    <v-tab-item>
      <Eraser />
    </v-tab-item>
  </v-tabs>
</template>

<script>
import Vue from "vue";
import Eraser from "./tools/Eraser.vue";
import Fixer from "./tools/Fixer.vue";

export default Vue.extend({
  name: "Herramientas",
  components: {
    Eraser,
    Fixer
  }
});
</script>

<style>
</style>